/* ==========================================================================
   WYNWOOD - HOW TO FEED FRESH            theme asset:  assets/htf.js
   Drives the transition planner on /pages/how-to-feed-fresh.

   NO FEEDING MATH LIVES HERE. Every calorie and ounce figure comes from
   wynfeed.js, the one shared copy of the formula, applied to diets.json.
   What this file does on top is plain arithmetic on those figures:
   the 25/50/75/100 ramp percentages, and how long a packet lasts.
   That is the same division of labour the Flow order note uses.

   The dog profile is read and written through wynprofile.js, the only
   module allowed to touch localStorage for the shared bus, so a weight
   typed here reaches every other calculator on the site. When that module
   is absent this file falls back to a read-modify-write of wyn_dog and
   never wholesale-replaces it.
   ========================================================================== */
(function () {
  'use strict';

  if (window.htfApp) { return; }
  window.htfApp = '2026-08-12a';

  var root = document.getElementById('htf');
  if (!root) { return; }

  /* ---------------------------------------------------------------- utils */
  function $(id) { return document.getElementById(id); }
  function q(sel, r) { return (r || root).querySelector(sel); }
  function qa(sel, r) { return Array.prototype.slice.call((r || root).querySelectorAll(sel)); }
  function txt(el, s) { if (el && el.textContent !== s) { el.textContent = s; } }
  function show(el, on) { if (el) { el.hidden = !on; } }
  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Boot dials, written by the section so every string stays editable in
     Liquid. A missing boot is fatal and says so rather than guessing. */
  var boot = {};
  try { boot = JSON.parse(($('htf-boot') || {}).textContent || '{}'); } catch (e) { boot = {}; }
  var COPY = boot.copy || {};
  function c(k, fallback) { return COPY[k] === undefined || COPY[k] === '' ? (fallback || '') : COPY[k]; }

  /* ------------------------------------------------------------ diagnostics
     A watchdog, not a spinner. The one lesson from the calculator outage is
     that a page which quietly shows a plausible wrong number is worse than
     one that says what is missing, so this names the file that failed. */
  function fail(msg) {
    var bar = $('htf-fail');
    if (!bar) { return; }
    txt(q('.htf-fail__t', bar), msg);
    show(bar, true);
    root.classList.add('htf-broken');
  }

  /* ============================================================== THE DOG
     Read and write go through wynprofile.js when it is there. The fallback
     merges into wyn_dog rather than replacing it, because several surfaces
     still wholesale-write that key and a replace here would delete their
     fields (the portion-deletion bug that was live on the calculator page). */
  var P = window.wynProfile || null;

  function readBus() {
    try { return JSON.parse(localStorage.getItem('wyn_dog') || 'null') || {}; }
    catch (e) { return {}; }
  }

  function dogGet() {
    if (P && P.get) { return P.get(); }
    var a = readBus();
    var lb = parseFloat(a.weight_lb);
    return {
      known: lb > 0,
      weight_lb: lb > 0 ? lb : null,
      age: a.age !== undefined && a.age !== '' ? Number(a.age) : null,
      ageMonths: null,
      activity: a.activity !== undefined && a.activity !== '' ? Number(a.activity) : null,
      portion: a.portion ? Number(a.portion) : null,
      neuter: null,
      name: a.name || null
    };
  }

  function dogSet(patch) {
    if (P && P.set) { return P.set(patch); }
    var a = readBus();
    if (patch.weight_lb !== undefined) {
      var lb = parseFloat(patch.weight_lb);
      if (lb >= 2 && lb <= 250) { a.weight_lb = Math.round(lb * 2) / 2; }
    }
    if (patch.ageMonths !== undefined && window.wynFeed) {
      a.age = String(window.wynFeed.ageFactorFromMonths(patch.ageMonths));
    }
    if (patch.activity !== undefined) {
      var ACTF = { low: 1.2, normal: 1.55, high: 1.75 };
      var v = ACTF[String(patch.activity).toLowerCase()] || Number(patch.activity);
      if (v > 0) { a.activity = String(v); }
    }
    if (patch.portion !== undefined && Number(patch.portion) > 0) { a.portion = Number(patch.portion); }
    if (patch.name !== undefined) { a.name = String(patch.name || '').trim(); }
    a.updated = Date.now();
    try { localStorage.setItem('wyn_dog', JSON.stringify(a)); } catch (e) {}
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('wyn:dog', { detail: a, bubbles: true }));
    } catch (e) {}
    return dogGet();
  }

  function dogPlanShape() {
    if (P && P.toPlan) { return P.toPlan(); }
    var g = dogGet(), p = {};
    if (g.weight_lb !== null) { p.weight_lb = g.weight_lb; }
    if (g.ageMonths !== null) { p.ageMonths = g.ageMonths; }
    else if (g.age !== null) { p.ageFactor = g.age; }
    if (g.activity !== null) { p.activity = g.activity; }
    if (g.neuter) { p.neuter = g.neuter; }
    return p;
  }

  /* ========================================================== PAGE STATE
     Only what belongs to THIS page lives in wyn_htf: which diet and pack the
     customer is planning for, when they are starting, how fast, and which
     days they have ticked off. The dog itself is never duplicated here. */
  var SKEY = 'wyn_htf';
  var S = { diet: '', pack: 0, slow: false, pendingHandle: null };

  function loadState() {
    var o = {};
    try { o = JSON.parse(localStorage.getItem(SKEY) || 'null') || {}; } catch (e) { o = {}; }
    if (typeof o.diet === 'string') { S.diet = o.diet; }
    if (Number(o.pack) > 0) { S.pack = Number(o.pack); }
    S.slow = !!o.slow;
    /* The food they are switching FROM lives in wyn_prev, which is section 4's
       key AND section 4's shape. This page WRITES that key but deliberately
       never reads it back on load - see the note above applyPrev(). */
  }

  function saveState() {
    try {
      localStorage.setItem(SKEY, JSON.stringify({
        diet: S.diet, pack: S.pack, slow: S.slow
      }));
    } catch (e) {}
  }

  /* ============================================================== DIETS
     One fetch of the file the finder, the calculator and the cart drawer
     already read. No calorie table of its own, so a diet added there
     appears here with no code change. */
  var DIETS = null;
  var LABELS = {};
  (function () {
    String(boot.dietLabels || '').split('|').forEach(function (pair) {
      var i = pair.indexOf('=');
      if (i > 0) { LABELS[pair.slice(0, i).trim().toLowerCase()] = pair.slice(i + 1).trim(); }
    });
  }());

  /* ***THE DIET'S THREE COLOURS, HIS OWN VALUES FROM THE TWO PRODUCT
     TEMPLATES.*** They are set as custom properties on the section root, so a
     single write moves the bezel behind the bowl and the tint on the diet
     selector at once. The section's own literals remain as the fallback, so if
     this never runs the page looks exactly as it does today. */
  var DIETCOL = {};
  (function () {
    String(boot.dietColors || '').split(',').forEach(function (pair) {
      var i = pair.indexOf('=');
      if (i < 0) { return; }
      var parts = pair.slice(i + 1).split('|');
      if (parts.length !== 3) { return; }
      DIETCOL[pair.slice(0, i).trim().toLowerCase()] = parts;
    });
  }());

  /* Ink or cream on a diet fill - the Our Food page's pillInk(), verbatim logic. */
  function relLum(hex) {
    var v = [1, 3, 5].map(function (i) {
      var c = parseInt(hex.substr(i, 2), 16) / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * v[0] + 0.7152 * v[1] + 0.0722 * v[2];
  }
  function contrast(a, b) {
    var l1 = relLum(a), l2 = relLum(b), t;
    if (l2 > l1) { t = l1; l1 = l2; l2 = t; }
    return (l1 + 0.05) / (l2 + 0.05);
  }
  function pillInk(hex) {
    if (!/^#[0-9a-fA-F]{6}$/.test(hex)) { return '#2E2E2E'; }
    if (contrast(hex, '#2E2E2E') >= 4.5) { return '#2E2E2E'; }
    var dark = contrast(hex, '#1A1A1A');
    return (dark >= 3 || dark >= contrast(hex, '#FDFAE4')) ? '#1A1A1A' : '#FDFAE4';
  }

  function applyDietColor() {
    var c3 = DIETCOL[String(S.diet).toLowerCase()];
    var names = ['--htf-diet', '--htf-hl', '--htf-bezel'];
    names.forEach(function (n, i) {
      if (c3) { root.style.setProperty(n, c3[i]); }
      else { root.style.removeProperty(n); }
    });
  }

  function title(k) {
    if (LABELS[k]) { return LABELS[k]; }
    return String(k).replace(/[a-z]+/g, function (w) {
      return w.charAt(0).toUpperCase() + w.slice(1);
    });
  }

  function loadDiets() {
    if (window.wynDiets) { return Promise.resolve(window.wynDiets); }
    if (!boot.dietsUrl) { return Promise.resolve(null); }
    return fetch(boot.dietsUrl)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        window.wynDiets = (j && j.diets) ? j.diets : (j || null);
        return window.wynDiets;
      })
      .catch(function () { return null; });
  }

  function isRx(key) {
    var d = DIETS && DIETS[key];
    return !!d && String(d.type || '').toLowerCase().indexOf('rx') > -1;
  }

  /* Pack sizes. Two for almost every diet; the keys named in packSingle
     ship in one size only, so they get one card and no chooser. */
  var SINGLE = String(boot.packSingle || '').toLowerCase().split(',')
    .map(function (s) { return s.trim(); }).filter(Boolean);
  var PACK_OZ = String(boot.packOz || '16,64').split(',')
    .map(Number).filter(function (n) { return n > 0; });
  var PACK_NAME = String(boot.packNames || 'Small,Large').split(',')
    .map(function (s) { return s.trim(); });

  function packsFor(key) {
    if (SINGLE.indexOf(String(key).toLowerCase()) > -1) {
      return [{ oz: PACK_OZ[0], name: PACK_NAME[0] || (PACK_OZ[0] + ' oz') }];
    }
    return PACK_OZ.map(function (oz, i) {
      return { oz: oz, name: PACK_NAME[i] || (oz + ' oz') };
    });
  }

  /* ============================================================ THE PLAN */
  var STAGES_FAST = [
    { from: 1, to: 3, pct: 25 },
    { from: 4, to: 6, pct: 50 },
    { from: 7, to: 9, pct: 75 },
    { from: 10, to: 10, pct: 100 }
  ];
  var STAGES_SLOW = [
    { from: 1, to: 4, pct: 25 },
    { from: 5, to: 8, pct: 50 },
    { from: 9, to: 12, pct: 75 },
    { from: 13, to: 13, pct: 100 }
  ];
  function stages() { return S.slow ? STAGES_SLOW : STAGES_FAST; }
  function lastDay() { var st = stages(); return st[st.length - 1].from; }
  function pctForDay(d) {
    var st = stages();
    for (var i = 0; i < st.length; i++) {
      if (d >= st[i].from && d <= st[i].to) { return st[i].pct; }
    }
    return 100;
  }

  var PLAN = null;

  function computePlan() {
    if (!window.wynFeed || !window.wynFeed.plan) { return null; }
    var key = S.diet;
    var diet = DIETS && DIETS[key];
    if (!diet) { return null; }
    var dog = dogGet();
    var example = !dog.weight_lb;

    var share = Number(dog.portion) || 100;
    /* A therapeutic diet fed as a topper is not the diet, so an Rx page
       offers All of it and Half only. A share carried over from a Complete
       page that has no cell here is clamped up, and the stored value is
       left alone so the Complete choice survives. Same rule, same wording
       as the cart drawer's clamp. */
    var allowed = isRx(key) ? [100, 50] : [100, 50, 25];
    if (allowed.indexOf(share) === -1) { share = 100; }

    /* ***THE PAGE IS NEVER BLANK.*** With no dog on file it works an average
       adult so every block below is populated and legible, and says plainly
       that the figures are an example until a real weight is typed. Nothing
       is written to the shared profile for the example dog. */
    var prof = example
      ? { weight_lb: Number(boot.exampleWeight) || 35, activity: 'normal', ageFactor: 1 }
      : dogPlanShape();
    var p;
    try {
      p = window.wynFeed.plan(prof, {
        key: key,
        kcal_per_kg: diet.kcal_per_kg,
        kcal_per_cup: diet.kcal_per_cup
      }, { portion: share });
    } catch (e) { return null; }
    if (!p) { return null; }

    /* The library is asked for the share, and the answer is checked rather
       than assumed. If a build ever ignores opts.portion the figures are
       scaled here instead, which is arithmetically identical - proven when
       the shared library was read - so the page cannot silently show a full
       portion to a topper customer. */
    if (p.portionPct !== share) {
      var f = share / 100;
      p = {
        kcalFull: p.kcalFull, kcal: p.kcal * f, grams: p.grams * f,
        oz: Math.round(p.oz * f * 4) / 4, cups: p.cups * f,
        portionPct: share, reduction: p.reduction
      };
    }

    p.example = example;
    p.share = share;
    p.allowed = allowed;
    p.key = key;
    p.diet = diet;
    /* The whole day's target intake, including any therapeutic reduction.
       Their food fills whatever we do not, so this is the number the other
       side of the bowl is measured against - not maintenance before the
       diet factor. */
    p.wholeDayKcal = p.kcal / (share / 100);
    return p;
  }

  function ozOnDay(d) {
    if (!PLAN) { return 0; }
    return Math.round(PLAN.oz * pctForDay(d) / 100 * 4) / 4;
  }
  function cupsOnDay(d) {
    if (!PLAN) { return 0; }
    return PLAN.cups * pctForDay(d) / 100;
  }
  /* What is left of their old food, as a share of their normal amount.
     At a full share this is the familiar 75/50/25/none. At a half share a
     customer is still feeding half their own food on the last day, which a
     plain "100 minus the stage" would have got wrong. */
  function restPct(d) {
    if (!PLAN) { return 0; }
    return Math.max(0, 100 - PLAN.share * pctForDay(d) / 100);
  }

  function fmtOz(v) {
    if (window.wynFeed && window.wynFeed.fmtOz) { return window.wynFeed.fmtOz(v); }
    return (Math.round(v * 4) / 4).toString();
  }
  function fmtCups(v) {
    if (window.wynFeed && window.wynFeed.fmtCups) { return window.wynFeed.fmtCups(v); }
    return (Math.round(v * 4) / 4).toString();
  }

  /* ====================================================== THE FRIDGE PLAN
     Packets are simulated one at a time rather than averaged, because the
     question a customer actually has is "which night do I move one down",
     and during the ramp they are eating a quarter of a portion, so an
     average over the ten days would be wrong on every one of them.

     A packet is thawed the night before it is first needed and has to be
     finished within thawDays of being opened. When a packet would outlast
     that window the answer is not "eat faster", it is to divide it and
     refreeze the part that is not needed yet. */
  function fridgePlan() {
    if (!PLAN || !S.pack) { return null; }
    var thawDays = Number(boot.thawDays) || 5;
    var horizon = lastDay() + 6;
    var open = [];
    var packets = 0;
    var overrun = false;
    var firstSpan = 0;

    for (var d = 1; d <= horizon; d++) {
      var need = ozOnDay(d);
      var have = 0;
      var i;
      for (i = 0; i < open.length; i++) { have += open[i].left; }
      while (have < need - 0.001) {
        open.push({ day: d, left: S.pack });
        have += S.pack;
        packets++;
      }
      var want = need;
      for (i = 0; i < open.length && want > 0.001; i++) {
        var take = Math.min(open[i].left, want);
        open[i].left -= take;
        want -= take;
      }
      open = open.filter(function (p) { return p.left > 0.001; });
      for (i = 0; i < open.length; i++) {
        if (d - open[i].day >= thawDays) { overrun = true; }
      }
    }
    /* How long the FIRST packet lasts at the full daily portion, which is
       the number to quote once the transition is over. */
    if (PLAN.oz > 0) { firstSpan = S.pack / PLAN.oz; }

    return {
      packets: packets,
      rampOver: overrun,
      steadyOver: firstSpan > thawDays,
      steadyDays: firstSpan,
      thawDays: thawDays,
      horizon: horizon
    };
  }

  /* ============================================================== RENDER */
  var FRIDGE = null;

  function dogName() {
    var g = dogGet();
    var n = g.name ? String(g.name).trim() : '';
    return n;
  }
  function subjectCap() { return dogName() || c('subject', 'Your dog'); }
  function subjectLow() { return dogName() || c('subjectLow', 'your dog'); }

  var AGEWORD = { 2: 'under 3 mo', 1.5: '3 to 6 mo', 1.25: '6 to 12 mo', 1: '1 to 7 yrs', 0.9: '7 yrs +' };
  var ACTWORD = { 1.2: 'low activity', 1.55: 'normal activity', 1.75: 'very active' };
  var PORWORD = { 100: '', 50: 'Wynwood as half their food', 25: 'Wynwood as a topper' };

  /* ***THE PAGE STATES WHAT IT KNOWS RATHER THAN ASKING FOR IT AGAIN.***
     Weight, age, activity and the name are already on the shared profile,
     filled either by another tool on the site or, for a signed-in customer,
     from their own record by the dog seed. So the default view is one
     sentence and two collapsed pickers; the questions only unfold if the
     answers are missing or the customer wants to change one. */
  function renderKnown() {
    var el = $('htf-known');
    var g = dogGet();
    var more = $('htf-more');

    /* ***THE DOG'S NAME IS THE HEADING.*** The card is about one animal, so it
       leads with that animal. Without a name it falls back to the section's
       own title, and the facts drop to the quiet line underneath either way. */
    txt($('htf-who'), dogName() || c('askFallback', 'Your dog'));

    if (!g.weight_lb) {
      if (el) {
        el.innerHTML = esc(c('unknownLead', '')) +
          ' <em>' + esc(c('unknownSub', '')) + '</em>';
      }
      /* Nothing on file, so the questions are open from the start. */
      if (more && !more.hasAttribute('data-htf-set')) {
        more.open = true;
        more.setAttribute('data-htf-set', '1');
      }
      return;
    }

    var bits = [g.weight_lb + ' ' + c('lbWord', 'lb')];
    var aw = AGEWORD[ageBucket()];
    if (aw) { bits.push(aw); }
    var cw = ACTWORD[Number(g.activity) || 1.55];
    if (cw) { bits.push(cw); }
    var pw = PORWORD[PLAN ? PLAN.share : 100];
    if (pw) { bits.push(pw); }
    if (el) { txt(el, bits.join(', ')); }

    if (more && !more.hasAttribute('data-htf-set')) {
      more.setAttribute('data-htf-set', '1');
    }
  }

  function renderHead() {
    var wt = $('htf-wt');
    if (wt) { wt.placeholder = String(Number(boot.exampleWeight) || 35); }

    if (!PLAN) {
      txt($('htf-line'), c('lineWaiting', 'Pick a diet to see the plan.'));
      txt($('htf-oz'), '--');
      txt($('htf-cups'), '--');
      txt($('htf-kcal'), '--');
      show($('htf-red'), false);
      return;
    }
    var who = PLAN.example ? c('exampleSubject', 'A 35 lb dog') : subjectCap();
    txt($('htf-line'), who + ' ' + c('lineVerb', 'eats') + ' ' +
      fmtOz(PLAN.oz) + ' ' + c('ozWord', 'oz') + ' ' +
      c('lineOf', 'of') + ' ' + title(PLAN.key) + ' ' +
      c('lineTail', 'a day once the switch is done.'));
    txt($('htf-oz'), fmtOz(PLAN.oz));
    txt($('htf-cups'), fmtCups(PLAN.cups));
    txt($('htf-kcal'), String(Math.round(PLAN.kcal)));

    /* His standing rule: a therapeutic reduction is never applied silently.
       The library returns it on every call so a caller cannot swallow it. */
    var red = PLAN.reduction;
    show($('htf-red'), !!red);
    if (red) {
      txt(q('.htf-red__t', $('htf-red')),
        c('redNote', 'This diet is portioned about {n}% below maintenance on purpose. Your veterinarian sets the target.')
          .replace('{n}', String(red)));
    }

    var shareRow = $('htf-share');
    if (shareRow) {
      qa('[data-htf-por]', shareRow).forEach(function (b) {
        var v = Number(b.getAttribute('data-htf-por'));
        var ok = PLAN.allowed.indexOf(v) > -1;
        b.hidden = !ok;
        var on = ok && v === PLAN.share;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-on', on);
      });
      show($('htf-sharenote'), PLAN.share !== 100);
      if (PLAN.share !== 100) {
        txt($('htf-sharenote'), (PLAN.share === 50
          ? c('shareHalf', 'You are feeding Wynwood as half their food, so the other half stays as it is all the way through.')
          : c('shareTop', 'You are feeding Wynwood as a topper, so most of the bowl stays their usual food.')));
      }
    }
  }

  function renderFridge() {
    var host = $('htf-fridgebody');
    if (!host) { return; }
    if (!PLAN || !FRIDGE || !S.pack) { host.innerHTML = ''; return; }
    var packName = '';
    packsFor(PLAN.key).forEach(function (p) { if (p.oz === S.pack) { packName = p.name; } });
    var span = FRIDGE.steadyDays;
    var spanTxt = span >= 2 ? String(Math.round(span * 2) / 2) : span.toFixed(1);
    var out = '';

    out += '<p class="htf-fr__lead">' +
      esc(c('fridgeLead', 'One {name} packet is about {days} days of food for {who} once the switch is done.')
        .replace('{name}', packName || (S.pack + ' oz'))
        .replace('{days}', spanTxt)
              .replace('{who}', subjectLow())) +
      '</p>';

    out += '<p class="htf-fr__lead">' +
      esc(c('fridgeCount', 'The whole transition takes about {n} packets.')
        .replace('{n}', String(FRIDGE.packets))) + '</p>';

    if (FRIDGE.steadyOver) {
      out += '<div class="htf-warn"><span class="htf-warn__dot" aria-hidden="true"></span>' +
        '<p>' + esc(c('overrun',
          'A packet this size lasts longer than {d} days for {who}, and thawed food keeps for {d} days. Thaw the packet, divide it into portions of about three days each, and put all but the first back in the freezer. Use the refrozen portions within three months.')
          .replace(/\{d\}/g, String(FRIDGE.thawDays))
          .replace('{who}', subjectLow())) +
        '</p></div>';
    } else if (FRIDGE.rampOver) {
      /* The packet is the right size for this dog eventually, but not yet. */
      out += '<div class="htf-warn htf-warn--soft"><span class="htf-warn__dot" aria-hidden="true"></span>' +
        '<p>' + esc(c('rampSplit', '').replace(/\{d\}/g, String(FRIDGE.thawDays))) +
        '</p></div>';
    }
    host.innerHTML = out;
  }

  /* Which of the three serving methods suits this dog, decided by the one
     fact that actually separates them: whether a packet lasts longer than the
     window it can stay thawed. Straight from the packet if it does not,
     portioned out if it does. The middle option is a preference, never a
     recommendation, so it is never badged. */
  /* ***THE PRINTED SHEET NEEDS ALL FOUR STEPS AND THE SCREEN ONLY EVER SHOWS
     ONE.*** The dial's readout carries the selected step, so a printout built
     from what is on screen would carry one of the four amounts. This table
     exists only on paper and is filled from the same stages() and the same
     figures the dial uses, so it cannot disagree with it. */
  function renderPrint() {
    var host = $('htf-printrows');
    if (!host) { return; }
    if (!PLAN) { host.innerHTML = ''; return; }
    var st = stages(), out = '', i;
    for (i = 0; i < st.length; i++) {
      var g = st[i];
      var when = g.from === g.to
        ? c('dayWord', 'Day') + ' ' + g.from + '+'
        : c('daysWord', 'Days') + ' ' + g.from + ' to ' + g.to;
      var rest = Math.round(100 - PLAN.share * g.pct / 100);
      var theirs = rest <= 0
        ? c('none', 'None')
        : (prev > 0 ? theirFrac(g.pct) + ' ' + c('ozWord', 'oz')
                    : rest + '% ' + c('ofUsual', 'of their usual'));
      out += '<tr><td>' + esc(when) + '</td><td>' + ozDial(oursG(g.pct) / OZ) +
        ' ' + esc(c('ozWord', 'oz')) + '</td><td>' + theirs + '</td></tr>';
    }
    host.innerHTML = out;
  }

  function renderServe() {
    var why = $('htf-servewhy');
    var cards = qa('[data-htf-serve]');
    if (!cards.length) { return; }
    if (!PLAN || !FRIDGE || !S.pack) {
      cards.forEach(function (el) { el.classList.remove('is-best'); });
      if (why) { txt(why, ''); }
      txt($('htf-servepack'), '');
      return;
    }
    var best = FRIDGE.steadyOver ? 3 : 1;
    cards.forEach(function (el) {
      el.classList.toggle('is-best', Number(el.getAttribute('data-htf-serve')) === best);
    });
    /* The packet line is written BEFORE the why guard, because it does not
       depend on that element existing and must not be skipped with it. */
    var packName = '';
    packsFor(PLAN.key).forEach(function (pk) { if (pk.oz === S.pack) { packName = pk.name; } });
    var span = FRIDGE.steadyDays;
    txt($('htf-servepack'), fill(c('servePack', ''), {
      name: packName || (S.pack + ' oz'),
      days: span >= 2 ? String(Math.round(span * 2) / 2) : span.toFixed(1),
      who: subjectLow()
    }));
    if (!why) { return; }
    var msg = best === 3 ? c('serveWhyLong', '') : c('serveWhyShort', '');
    txt(why, fill(msg, { who: subjectLow() }));
  }

  function renderAll() {
    PLAN = computePlan();
    FRIDGE = fridgePlan();
    applyDietColor();
    renderKnown();
    renderHead();
    buildSteps();
    renderRamp();
    renderFridge();
    renderServe();
    renderPrint();
    renderControls();
  }


  /* ================================================== THE TRANSITION DIAL
     PORTED FROM PRODUCT PAGE SECTION 4, NOT REBUILT. The look is entirely
     wofp-feed.css, which this page LINKS rather than copies, so the two
     surfaces cannot drift apart. The code below is section 4's own, with
     three substitutions: gramsDay, the whole-day calories and our share come
     from the wynFeed PLAN instead of an inline formula, and the copy keys
     come from this section's boot. */
  var OZ = 28.349523125;
  var FR = { 1: ['1', '8', 'an eighth'], 2: ['1', '4', 'a quarter'], 3: ['3', '8', 'three eighths'],
             4: ['1', '2', 'a half'], 5: ['5', '8', 'five eighths'], 6: ['3', '4', 'three quarters'],
             7: ['7', '8', 'seven eighths'] };
  var dialI = 0, dialA = 0, dialRAF = 0, dialOn = 0;
  var prev = 0, setLo = 0, setHi = 0, setName = '';
  var PREVKEY = 'wyn_prev';

  function fracHtml(r, w) {
    var f = FR[r];
    return '<span class="wofpp-frac" aria-hidden="true"><span class="wofpp-frac__n">' + f[0] +
      '</span><span class="wofpp-frac__d">' + f[1] + '</span></span><span class="wofpp-sr">' +
      (w ? ' and ' : ' ') + f[2] + '</span>';
  }
  function fmtFrac(n, d) {
    var qn = Math.round(n * d);
    var w = Math.floor(qn / d);
    var r = (qn - w * d) * (8 / d);
    if (!(w > 0)) { return r ? fracHtml(r, 0) : '0'; }
    return String(w) + (r ? fracHtml(r, 1) : '');
  }
  function c1(n) { return (Math.round(n * 10) / 10).toFixed(1); }
  function ozFrac(n) { return fmtFrac(n, 4); }
  /* Below one ounce a stacked fraction has no whole number to attach to and a
     screen reader would say "and a half" with nothing in front of it. */
  function ozDial(n) { return n < 1 ? c1(n) : ozFrac(n); }
  function ozTxt(n) { return String(Math.round(n * 4) / 4); }
  function thou(v) { return String(Math.round(v)).replace(/\B(?=(\d{3})+$)/g, ','); }
  function fill(str, map) {
    return String(str).replace(/\{(\w+)\}/g, function (m, k) { return map[k] == null ? '' : map[k]; });
  }
  function stillMotion() {
    try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
    catch (e) { return false; }
  }

  function isRange() { return setLo > 0 && setHi > setLo; }
  function prevOdd() {
    return !isRange() && (prev < (Number(boot.prevLo) || 600) || prev > (Number(boot.prevHi) || 6000));
  }
  function gramsDay() { return PLAN ? PLAN.grams : 0; }
  function oursG(pct) { return gramsDay() * pct / 100; }
  function theirG(kk, pct) {
    if (!PLAN || !(kk > 0)) { return 0; }
    var k = PLAN.wholeDayKcal - PLAN.kcal * pct / 100;
    return k > 0 ? k / kk * 1000 : 0;
  }
  function theirFrac(pct) {
    return (isRange() ? '\u2248 ' : '') + ozDial(theirG(prev, pct) / OZ);
  }

  function dialTarget() {
    var st = stages();
    return st.length ? st[Math.min(dialI, st.length - 1)].pct * 3.6 : 0;
  }
  function paintDial(a) {
    var d = $('wofpp-dial'), sm = $('wofpp-seam');
    dialA = a;
    if (d) { d.style.setProperty('--a', a + 'deg'); d.setAttribute('data-full', a >= 359.5 ? '1' : '0'); }
    if (sm) { sm.style.setProperty('--s', (180 + a) + 'deg'); }
  }
  function tweenDial(to) {
    if (dialRAF) { cancelAnimationFrame(dialRAF); dialRAF = 0; }
    if (stillMotion() || !window.requestAnimationFrame) { paintDial(to); return; }
    var from = dialA, t0 = 0;
    dialRAF = requestAnimationFrame(function step(now) {
      if (!t0) { t0 = now; }
      var k = (now - t0) / 520;
      if (k > 1) { k = 1; }
      paintDial(from + (to - from) * (1 - Math.pow(1 - k, 3)));
      if (k < 1) { dialRAF = requestAnimationFrame(step); } else { dialRAF = 0; }
    });
  }

  /* The step buttons are built from the same stages() the day list uses, so a
     button can never disagree with the rows underneath it. */
  function buildSteps() {
    var host = $('wofpp-steps');
    if (!host) { return; }
    var st = stages(), sig = st.length + ':' + (S.slow ? 1 : 0), out = '', i;
    if (host.getAttribute('data-htf-sig') === sig) { return; }
    for (i = 0; i < st.length; i++) {
      var g = st[i];
      var lab = g.from === g.to
        ? c('dayWord', 'Day') + ' ' + g.from + '+'
        : c('daysWord', 'Days') + ' ' + g.from + ' to ' + g.to;
      out += '<button type="button" class="wofpp-step" role="radio" aria-checked="' +
        (i === dialI ? 'true' : 'false') + '" tabindex="' + (i === dialI ? '0' : '-1') +
        '" data-p="' + g.pct + '"><span class="wofpp-step__d">' + esc(lab) +
        '</span><span class="wofpp-step__p">' + g.pct + '% ' + esc(c('ours', 'Wynwood')) +
        '</span></button>';
    }
    host.innerHTML = out;
    host.setAttribute('data-htf-sig', sig);
    wireDial();
  }

  function renderRamp() {
    var steps = $('wofpp-steps');
    var st = stages();
    if (!steps || !st.length) { renderSwapNote(); return; }
    if (dialI >= st.length) { dialI = 0; }
    var g = st[dialI], i, b;
    for (i = 0; i < steps.children.length; i++) {
      b = steps.children[i];
      b.setAttribute('aria-checked', i === dialI ? 'true' : 'false');
      b.tabIndex = i === dialI ? 0 : -1;
    }
    b = steps.children[dialI];
    txt($('wofpp-rd-d'), b ? b.querySelector('.wofpp-step__d').textContent : '');
    if (!PLAN) { renderSwapNote(); return; }
    txt($('wofpp-rd-w'), title(PLAN.key));
    var rest = Math.round(100 - PLAN.share * g.pct / 100);
    var tv = $('wofpp-rd-t'), tu = $('wofpp-rd-tu'), val, unit;
    if (rest <= 0) { val = c('none', 'None'); unit = ''; }
    else if (prev > 0) { val = theirFrac(g.pct); unit = c('ozWord', 'oz'); }
    else { val = rest + '%'; unit = c('ofUsual', 'of their usual'); }
    $('wofpp-rd-o').innerHTML = ozDial(oursG(g.pct) / OZ);
    tv.innerHTML = val;
    tu.hidden = !unit;
    tu.textContent = unit;
    (dialOn ? tweenDial : paintDial)(dialTarget());
    renderSwapNote();
  }

  function goDial(i) {
    var st = stages();
    if (i < 0 || i >= st.length) { return; }
    dialI = i;
    renderRamp();
  }
  function wireDial() {
    var steps = $('wofpp-steps');
    if (!steps) { return; }
    var kids = steps.children, L = kids.length, i;
    for (i = 0; i < L; i++) {
      (function (n, el) {
        el.addEventListener('click', function () { goDial(n); });
        el.addEventListener('keydown', function (e) {
          var t = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { t = (n + 1) % L; }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { t = (n + L - 1) % L; }
          if (t < 0) { return; }
          e.preventDefault();
          goDial(t);
          kids[t].focus();
        });
      }(i, kids[i]));
    }
    if (dialOn) { return; }
    dialOn = 1;
    var target = dialTarget();
    if (stillMotion() || !window.IntersectionObserver) { paintDial(target); return; }
    var d = $('wofpp-dial');
    if (!d || d.getBoundingClientRect().top < window.innerHeight * 0.8) { paintDial(target); return; }
    var fired = false;
    var io = new IntersectionObserver(function (en) {
      var k;
      for (k = 0; k < en.length; k++) {
        if (en[k].isIntersecting && !fired) { fired = true; tweenDial(target); io.disconnect(); }
      }
    }, { threshold: 0.35 });
    paintDial(0);
    io.observe(d);
    setTimeout(function () { if (!fired) { fired = true; paintDial(target); } }, 2600);
  }

  function renderSwapNote() {
    var el = $('wofpp-swap-note'), clr = $('wofpp-prev-clr'), ap = $('wofpp-approx');
    if (clr) { clr.hidden = !(prev > 0); }
    if (ap) { ap.hidden = !isRange(); }
    if (!el) { return; }
    if (!(prev > 0)) { txt(el, ''); el.classList.remove('is-bad'); return; }
    if (prevOdd()) { txt(el, c('swapBad', '')); el.classList.add('is-bad'); return; }
    el.classList.remove('is-bad');
    if (isRange()) {
      txt(el, fill(c('swapEst', ''), { label: setName, lo: thou(setLo), hi: thou(setHi) }));
      return;
    }
    if (!PLAN) { txt(el, ''); return; }
    var st = stages();
    var sp = st.length ? st[Math.min(dialI, st.length - 1)].pct : 100;
    txt(el, fill(c('swapWhy', ''), {
      kc: thou(PLAN.wholeDayKcal),
      a: ozTxt(oursG(sp) / OZ),
      b: ozTxt(theirG(prev, sp) / OZ)
    }));
  }

  function markSets() {
    qa('.wofpp-swap__set').forEach(function (b) {
      var on = isRange() && parseFloat(b.getAttribute('data-lo')) === setLo &&
        parseFloat(b.getAttribute('data-hi')) === setHi;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    renderPick();
  }
  function renderPick() {
    var el = $('wofpp-swap-pick'), u;
    if (!el) { return; }
    if (setName) { txt(el, setName); return; }
    u = q('.wofpp-swap__u');
    txt(el, prev > 0 ? thou(prev) + (u ? ' ' + u.textContent : '') : '');
  }
  /* ***THE STORED SHAPE IS SECTION 4's, NOT THIS PAGE'S.*** It writes
     {k, lo, hi, n} for a preset and {k} for a typed number, and removes the key
     at zero. Writing any other shape here would break the product page's
     reader, which is the whole reason for sharing the key at all. */
  function applyPrev() {
    try {
      if (prev > 0) {
        localStorage.setItem(PREVKEY, JSON.stringify(isRange()
          ? { k: prev, lo: setLo, hi: setHi, n: setName } : { k: prev }));
      } else { localStorage.removeItem(PREVKEY); }
    } catch (e) {}
    markSets();
    try { renderRamp(); } catch (e) {}
  }
  function prevSet(v) {
    var p = parseFloat(v);
    setLo = 0; setHi = 0; setName = '';
    prev = p > 0 ? p : 0;
    applyPrev();
  }
  function setPick(lo, hi, name) {
    setLo = lo; setHi = hi; setName = name;
    prev = (lo + hi) / 2;
    var f = $('wofpp-prev');
    if (f) { f.value = Math.round(prev); }
    applyPrev();
  }
  /* ***THIS PAGE DELIBERATELY DOES NOT RESTORE wyn_prev ON LOAD.*** There was a
     loadPrev() here that read the key back into the swap box; it was removed on
     purpose, so every visit starts with "What are they eating now?" empty and
     THEIR CURRENT FOOD reads as a percentage of their usual until the customer
     says otherwise. The key itself is untouched: applyPrev() above still WRITES
     it in section 4's shape and the product page still reads it, so nothing
     entered elsewhere is lost. */

  function wireSwap() {
    var host = $('wofpp-swap');
    if (!host) { return; }
    host.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button') : null;
      if (!b || !host.contains(b)) { return; }
      if (b.classList.contains('wofpp-swap__set')) {
        setPick(parseFloat(b.getAttribute('data-lo')), parseFloat(b.getAttribute('data-hi')),
          b.textContent.trim());
        return;
      }
      if (b.id === 'wofpp-prev-clr') {
        var f = $('wofpp-prev');
        if (f) { f.value = ''; }
        prevSet(0);
      }
    });
    var pf = $('wofpp-prev');
    if (pf) { pf.addEventListener('input', function () { prevSet(pf.value); }); }
  }

  /* ============================================================ CONTROLS */
  function renderDietPicker() {
    var host = $('htf-diets');
    if (!host || !DIETS) { return; }
    var groups = [
      { type: 'complete', label: c('groupCB', 'Complete & Balanced') },
      { type: 'rx', label: c('groupRx', 'Fresh Rx') }
    ];
    var out = '';
    groups.forEach(function (g) {
      var rows = '';
      Object.keys(DIETS).forEach(function (k) {
        var t = String(DIETS[k].type || '').toLowerCase();
        var isR = t.indexOf('rx') > -1;
        if ((g.type === 'rx') !== isR) { return; }
        /* Colour pill, same shape as the Our Food ingredients pills and the weight
           management page: diet fill from DIETCOL, ink or cream text chosen by
           contrast (pillInk). No RX tab here - the Fresh Rx group heading already says it. */
        var c3 = DIETCOL[k] || null;
        var fill = c3 ? c3[0] : '#E4E2D4';
        rows += '<button type="button" class="htf-chip htf-chip--diet' + (k === S.diet ? ' is-on' : '') +
          '" data-htf-diet="' + esc(k) + '" aria-pressed="' + (k === S.diet ? 'true' : 'false') +
          '" style="--dc:' + esc(fill) + ';--dci:' + pillInk(fill) + '">' +
          '<span class="htf-chip__t">' + esc(title(k)) + '</span></button>';
      });
      if (rows) {
        out += '<p class="htf-grp">' + esc(g.label) + '</p><div class="htf-chips">' + rows + '</div>';
      }
    });
    host.innerHTML = out;
  }

  function renderControls() {
    var wt = $('htf-wt');
    var g = dogGet();
    if (wt && document.activeElement !== wt) {
      wt.value = g.weight_lb !== null ? String(g.weight_lb) : '';
    }
    var nm = $('htf-name');
    if (nm && document.activeElement !== nm && g.name) { nm.value = g.name; }

    qa('[data-htf-age]').forEach(function (b) {
      var on = Number(b.getAttribute('data-htf-age')) === ageBucket();
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
    });
    qa('[data-htf-act]').forEach(function (b) {
      var on = Number(b.getAttribute('data-htf-act')) === (Number(g.activity) || 1.55);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
    });
    qa('[data-htf-diet]').forEach(function (b) {
      var on = b.getAttribute('data-htf-diet') === S.diet;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
    });

    var packHost = $('htf-packs');
    if (packHost && S.diet) {
      var list = packsFor(S.diet);
      var out = '';
      list.forEach(function (p) {
        out += '<button type="button" class="htf-chip' + (p.oz === S.pack ? ' is-on' : '') +
          '" data-htf-pack="' + p.oz + '" aria-pressed="' + (p.oz === S.pack ? 'true' : 'false') + '">' +
          esc(p.name) + ' <i>' + p.oz + ' oz</i></button>';
      });
      if (packHost.getAttribute('data-htf-for') !== S.diet) {
        packHost.innerHTML = out;
        packHost.setAttribute('data-htf-for', S.diet);
      } else {
        qa('[data-htf-pack]', packHost).forEach(function (b) {
          var on = Number(b.getAttribute('data-htf-pack')) === S.pack;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.classList.toggle('is-on', on);
        });
      }
    }

    var dv = $('htf-dietv');
    if (dv && S.diet) { txt(dv, title(S.diet)); }
    var mv = $('htf-morev');
    if (mv) {
      var g2 = dogGet();
      txt(mv, g2.weight_lb ? g2.weight_lb + ' ' + c('lbWord', 'lb') : c('moreEmpty', ''));
    }
    var slow = $('htf-slow');
    if (slow) {
      slow.setAttribute('aria-pressed', S.slow ? 'true' : 'false');
      slow.classList.toggle('is-on', S.slow);
      txt(slow, S.slow ? c('slowOn', '') : c('slowOff', ''));
    }
    txt($('htf-pacenote'), S.slow ? c('pace14', '') : c('pace10', ''));
  }

  /* Four bands rather than three. A ten week old puppy needs roughly twice
     maintenance and a ten month old needs a quarter over, so folding both
     into one "Puppy" chip would be wrong by more than half a bowl. */
  function ageBucket() {
    var f = Number(dogGet().age);
    if (!f) { return 1; }
    if (f >= 2) { return 2; }
    if (f >= 1.5) { return 1.5; }
    if (f >= 1.25) { return 1.25; }
    if (f <= 0.9) { return 0.9; }
    return 1;
  }

  /* ***THE BANDS ARE THE LIBRARY'S OWN BUCKETS, NOT A TIDIER SET OF THREE.***
     A ten week old puppy needs twice maintenance and a four month old needs
     half again, so a single "Puppy" chip would be wrong by a third of a bowl
     for whichever end of it the customer actually has. The month value
     written back is the middle of the band, so the shared profile keeps a
     real number for the surfaces that want one. */
  var AGE_MONTHS = { 2: 2, 1.5: 4, 1.25: 9, 1: 36, 0.9: 108 };

  function wire() {
    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t || !root.contains(t)) { return; }

      var v;
      if ((v = t.getAttribute('data-htf-diet'))) {
        S.diet = v;
        var packs = packsFor(v);
        var ok = packs.some(function (p) { return p.oz === S.pack; });
        if (!ok) { S.pack = packs[packs.length - 1].oz; }
        var dp = $('htf-dietpick');
        if (dp) { dp.open = false; }
        saveState(); renderDietPicker(); renderAll(); return;
      }
      if ((v = t.getAttribute('data-htf-pack'))) {
        S.pack = Number(v); saveState(); renderAll(); return;
      }
      if ((v = t.getAttribute('data-htf-wt'))) {
        var cur = Number(dogGet().weight_lb) || Number(boot.exampleWeight) || 35;
        var next = Math.round(clamp(cur + Number(v), 2, 250));
        dogSet({ weight_lb: next });
        renderAll();
        return;
      }
      if ((v = t.getAttribute('data-htf-age'))) {
        dogSet({ ageMonths: AGE_MONTHS[Number(v)] }); renderAll(); return;
      }
      if ((v = t.getAttribute('data-htf-act'))) {
        dogSet({ activity: Number(v) }); renderAll(); return;
      }
      if ((v = t.getAttribute('data-htf-por'))) {
        dogSet({ portion: Number(v) }); renderAll(); return;
      }
      if (t.id === 'htf-slow') { S.slow = !S.slow; saveState(); renderAll(); return; }
      if (t.id === 'htf-print') { window.print(); return; }
    });

    /* Typed fields are debounced so a drag or a fast typist does not write
       the profile on every keystroke, and the weight is only saved once it
       is a usable number - a half-typed "1" is not a 1 lb dog. */
    var pending = null;
    function later(fn) { clearTimeout(pending); pending = setTimeout(fn, 350); }

    var wt = $('htf-wt');
    if (wt) {
      wt.addEventListener('input', function () {
        var lb = parseFloat(wt.value);
        if (!(lb >= 2 && lb <= 250)) { return; }
        later(function () { dogSet({ weight_lb: lb }); renderAll(); });
      });
      wt.addEventListener('change', function () {
        var lb = parseFloat(wt.value);
        if (lb >= 2 && lb <= 250) { dogSet({ weight_lb: lb }); }
        renderAll();
      });
    }
    var nm = $('htf-name');
    if (nm) {
      nm.addEventListener('input', function () {
        later(function () { dogSet({ name: nm.value.trim() }); renderAll(); });
      });
    }

    /* Another surface changing the dog repaints this page. The listener is
       on document because the product engines dispatch there, and events
       only travel upward. */
    document.addEventListener('wyn:dog', function () { renderAll(); });
  }

  /* ============================================================ THE JAR SPIN
     A sprite-sheet turntable, ported from the supplements page factory so the
     two surfaces behave identically. Every constant comes off the element as
     a data attribute, written by the section, so the sheet can be re-exported
     without touching this file.

     THREE THINGS HERE ARE LOAD-BEARING AND WERE EACH A MEASURED BUG FIX:
     1. degPerPx reads offsetWidth, the LAYOUT width. getBoundingClientRect
        includes any transform, which changes the gearing mid-gesture.
     2. The sheet is decoded with img.decode() BEFORE it is applied. Assigning
        backgroundImage in onload defers the decode to first paint, i.e. into
        the middle of the drag that triggered it (472 ms of "sticky").
     3. Paints are coalesced into one rAF. A 120 Hz finger otherwise repaints a
        1000%-scaled background once per pointermove.

     Poster first: the sheet is about 1 MB and is not fetched until someone
     actually reaches for the jar. The poster is frame 0, so nothing moves. */
  function wireSpin() {
    qa('.htf-spin').forEach(function (el) {
      var face = q('.htf-spin__f', el);
      if (!face) { return; }

      var N = Math.max(2, Number(el.getAttribute('data-n')) || 48);
      var COLS = Math.max(1, Number(el.getAttribute('data-cols')) || 8);
      var ROWS = Math.max(1, Number(el.getAttribute('data-rows')) || 6);
      var sheet = el.getAttribute('data-sheet');
      var ANG = [], theta = 0, cur = -1, want = -1, prf = null;
      var loaded = false, asked = false, drag = false, pid = null, lastX = 0, vel = 0, raf = null;

      var raw = (el.getAttribute('data-ang') || '').split(',');
      for (var a = 0; a < N; a++) {
        var v = parseFloat(raw[a]);
        ANG.push(isFinite(v) ? ((v % 360) + 360) % 360 : (360 * a / N));
      }

      function nearest(t) {
        t = ((t % 360) + 360) % 360;
        var best = 0, bd = 1e9, k, d;
        for (k = 0; k < N; k++) {
          d = Math.abs(ANG[k] - t);
          if (d > 180) { d = 360 - d; }
          if (d < bd) { bd = d; best = k; }
        }
        return best;
      }
      function paint() {
        prf = null;
        if (want === cur) { return; }
        cur = want;
        face.style.backgroundPosition =
          ((cur % COLS) * (100 / (COLS - 1))).toFixed(4) + '% ' +
          (Math.floor(cur / COLS) * (100 / (ROWS - 1))).toFixed(4) + '%';
      }
      function frame(k) {
        want = k;
        if (prf === null) { prf = requestAnimationFrame(paint); }
      }
      function killHint() { if (el.parentNode) { el.parentNode.classList.add('touched'); } }
      function load() {
        if (asked || !sheet) { return; }
        asked = true;
        var im = new Image();
        function apply() {
          loaded = true;
          face.style.backgroundImage = 'url("' + sheet + '")';
          face.classList.add('ready');
          el.classList.add('loaded');
          cur = -1;
          frame(nearest(theta));
        }
        im.onload = function () {
          if (im.decode) { im.decode().then(apply)['catch'](apply); } else { apply(); }
        };
        im.onerror = function () { loaded = false; };
        im.src = sheet;
      }
      function degPerPx() { return 360 / ((el.offsetWidth || 300) * 1.15); }
      function glide() {
        raf = null;
        if (Math.abs(vel) < 0.25) { return; }
        theta += vel;
        frame(nearest(theta));
        vel *= 0.91;
        raf = requestAnimationFrame(glide);
      }
      function release(e) {
        if (!drag || (e && e.pointerId !== pid)) { return; }
        drag = false;
        try { el.releasePointerCapture(pid); } catch (err) {}
        if (Math.abs(vel) > 0.4 && !raf) { raf = requestAnimationFrame(glide); }
      }

      el.addEventListener('pointerdown', function (e) {
        killHint();
        drag = true; pid = e.pointerId; lastX = e.clientX; vel = 0;
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        try { el.setPointerCapture(pid); } catch (err) {}
      });
      el.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== pid) { return; }
        var d = -(e.clientX - lastX) * degPerPx();
        lastX = e.clientX;
        theta += d;
        vel = clamp(d, -14, 14);
        frame(nearest(theta));
      });
      el.addEventListener('pointerup', release);
      el.addEventListener('pointercancel', release);
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
      el.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k !== 'ArrowLeft' && k !== 'ArrowRight' && k !== 'Home') { return; }
        e.preventDefault();
        killHint();
        if (k === 'Home') { theta = 0; } else {
          var i0 = nearest(theta), j0 = (k === 'ArrowLeft') ? (i0 + N - 1) % N : (i0 + 1) % N;
          var t0 = Math.floor(theta / 360) * 360 + ANG[j0];
          while (t0 - theta > 180) { t0 -= 360; }
          while (theta - t0 > 180) { t0 += 360; }
          theta = t0;
        }
        frame(nearest(theta));
      });

      ['pointerdown', 'pointerenter', 'focus', 'keydown'].forEach(function (ev) {
        el.addEventListener(ev, load);
      });
    });
  }

  /* ==================================================== THE REFERENCE TABLE
     The table in the reference block is STATIC MARKUP on purpose: it is the
     only feeding figure on this page a crawler or an assistant can read
     without running the tool. The cost of that is drift - change a
     kcal_per_kg in diets.json and the table silently becomes a lie, which is
     exactly the failure that destroys the authority the table exists to
     build. So every cell is recomputed here against the same library the page
     uses and any disagreement is named in the console.
     ***THIS NEVER TOUCHES THE DOM.*** Rewriting the cells at runtime would put
     the numbers back inside JavaScript and undo the whole point. */
  function checkRefTable() {
    var t = q('[data-htf-ref]');
    if (!t || !DIETS || !window.wynFeed || !window.wynFeed.plan) { return; }
    var cols = qa('thead th', t);
    var bad = [];
    qa('tbody tr', t).forEach(function (tr) {
      var lb = Number(tr.getAttribute('data-lb'));
      if (!(lb > 0)) { return; }
      var cells = qa('td', tr);
      cols.forEach(function (th, i) {
        var cell = cells[i - 1];
        if (!cell) { return; }
        var want, got = cell.textContent.trim();
        if (th.getAttribute('data-kcal')) {
          var any = DIETS[Object.keys(DIETS)[0]];
          want = String(Math.round(window.wynFeed.plan(
            { weight_lb: lb, activity: 'normal', ageFactor: 1 },
            { key: '', kcal_per_kg: any.kcal_per_kg, kcal_per_cup: any.kcal_per_cup }
          ).kcal));
        } else {
          var k = th.getAttribute('data-diet');
          var d = k && DIETS[k];
          if (!d) { return; }
          want = fmtOzPlain(window.wynFeed.plan(
            { weight_lb: lb, activity: 'normal', ageFactor: 1 },
            { key: k, kcal_per_kg: d.kcal_per_kg, kcal_per_cup: d.kcal_per_cup }
          ).oz);
        }
        if (want !== got) { bad.push(lb + ' lb / ' + (th.textContent.trim()) + ': printed ' + got + ', computed ' + want); }
      });
    });
    if (bad.length) {
      window.console && console.error('htf.js: the printed feeding reference table no longer matches the ' +
        'calculator. ' + bad.length + ' cell(s) have drifted, most likely because diets.json changed. ' +
        'Regenerate the table in the section.\n' + bad.join('\n'));
    }
  }
  /* The table prints plain text fractions ("21 3/4"), not the stacked markup
     the rest of the page uses, so it needs its own tiny formatter. */
  function fmtOzPlain(v) {
    var w = Math.floor(v), r = Math.round((v - w) * 4);
    var tail = ['', ' 1/4', ' 1/2', ' 3/4'][r];
    if (r === 4) { w += 1; tail = ''; }
    return w > 0 ? String(w) + tail : (tail.replace(/^ /, '') || '0');
  }

  /* ============================================================ ADD TO CART
     The band's button adds the probiotic without leaving the page. Ported from
     the supplements section so the two behave identically: one POST to
     /cart/add.js asking for the mini-cart section back, swap it in, then fire
     the events the theme listens for.
     ***THE BUTTON ONLY EXISTS WHEN LIQUID SAW THE PRODUCT AS AVAILABLE.***
     Otherwise the section renders a plain link instead, so this wires nothing
     and there is no path to a dead button. */
  function wireBuy() {
    var btn = $('htf-buy');
    if (!btn) { return; }
    var id = btn.getAttribute('data-id');
    if (!id) { return; }
    var label = q('.htf-buy__p', btn);
    var price = label ? label.outerHTML : '';
    var t = 0;
    function say(word, keepPrice) {
      btn.innerHTML = esc(word) + (keepPrice ? ' ' + price : '');
    }
    btn.addEventListener('click', function () {
      if (btn.disabled) { return; }
      btn.disabled = true;
      say(btn.getAttribute('data-adding') || 'Adding', false);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'mini-cart' })
      }).then(function (r) { return r.json(); }).then(function (d) {
        /* Swapping the returned mini-cart markup keeps the drawer in step
           without a page load. If the theme ever stops returning it, the add
           still succeeded and only the drawer is stale. */
        if (d && d.sections && d.sections['mini-cart']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = d.sections['mini-cart'];
          var fresh = tmp.querySelector('#mini-cart'), live = document.getElementById('mini-cart');
          if (fresh && live) { live.innerHTML = fresh.innerHTML; }
        }
        ['variant:added', 'cart:updated', 'cart:refresh'].forEach(function (n) {
          try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
        });
        btn.classList.add('is-added');
        say(btn.getAttribute('data-added') || 'Added', false);
        if (t) { clearTimeout(t); }
        t = setTimeout(function () {
          btn.classList.remove('is-added');
          say(btn.getAttribute('data-idle') || 'Add to cart', true);
          btn.disabled = false;
        }, 2200);
      })['catch'](function () {
        say(btn.getAttribute('data-retry') || 'Try again', false);
        btn.disabled = false;
      });
    });
  }

  /* ================================================================ BOOT */
  function start() {
    loadState();

    /* A diet already in the cart is the one they are almost certainly
       asking about, so it is preselected. Written onto the section by
       Liquid, which can read the cart and this file cannot. */
    if (!S.diet && boot.cartHandle) { S.pendingHandle = boot.cartHandle; }

    wire();
    wireSwap();
    markSets();
    wireSpin();
    wireBuy();
    renderControls();

    try {
      if (!getComputedStyle(root).getPropertyValue('--htf-css').trim()) {
        fail(c('failCss', ''));
      }
    } catch (e) {}

    if (!window.wynFeed) {
      fail(c('failFeed', 'The shared feeding library (wynfeed.js) did not load, so the numbers on this page are not being calculated. Nothing here is wrong, it is just missing.'));
    }

    loadDiets().then(function (d) {
      DIETS = d;
      if (!DIETS) {
        fail(c('failDiets', 'The diet list did not load, so portions cannot be worked out. The guidance below is still correct.'));
        return;
      }
      if (S.pendingHandle) {
        Object.keys(DIETS).forEach(function (k) {
          if (DIETS[k].handle === S.pendingHandle) { S.diet = k; }
        });
        S.pendingHandle = null;
      }
      if (!S.diet || !DIETS[S.diet]) {
        S.diet = boot.defaultDiet && DIETS[boot.defaultDiet] ? boot.defaultDiet : Object.keys(DIETS)[0];
      }
      /* A pack size restored from a previous visit is checked against the
         diet now chosen. The single size diets have no large packet, so a 64
         carried over from a Complete diet would otherwise drive the whole
         fridge plan off a packet that does not exist. */
      var packs = packsFor(S.diet);
      if (!S.pack || !packs.some(function (x) { return x.oz === S.pack; })) {
        S.pack = packs[packs.length - 1].oz;
      }
      saveState();
      renderDietPicker();
      renderAll();
      checkRefTable();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());